module.exports = __webpack_public_path__ + "static/media/picki.73a101e6.svg";